import React, { createContext, useReducer } from "react";
import { sessionStorageKey } from "../Config/Constants";
import { logger } from "../Middleware/Logger";
import UserState from "../Models/User/UserState";
import defaultState from "../State/User/defaultState";
import UserReducer from "../State/User/Reducer";

const UserDataContext = createContext<UserState>({
  state: defaultState,
  dispatch: () => {},
});

type Props = {
  children: React.ReactNode;
};

export const UserDataContextProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(UserReducer, defaultState, () => {
    try {
      const saveState = sessionStorage.getItem(sessionStorageKey.USER_STATE);
      if (saveState) {
        return JSON.parse(saveState);
      }
      return defaultState;
    } catch (error) {
      logger.error("🚀 ~ file: UserDataContext.context.tsx ~ line 18 ~ useReducer ~ error", error);
    }
  });
  return <UserDataContext.Provider value={{ state, dispatch }}>{children}</UserDataContext.Provider>;
};

export default UserDataContext;
